import React from "react";

export type ColumnExerciseInformationAvatarProps = {
  image: string;
  name: string;
};

const ColumnExerciseInformationAvatar: React.FC<
  ColumnExerciseInformationAvatarProps
> = ({ image, name }) => {
  return (
    <td className="py-5 pl-4 pr-3 text-sm sm:pl-0 max-w-xs text-left">
      <div className="flex items-center">
        <div className="h-16 w-16 flex-shrink-0">
          <img src={image} className="h-16 w-16 rounded-md" alt="avatar" />
        </div>
        <div className="ml-4">
          {/* El nombre se oculta en pantallas móviles y aparece en pantallas >= sm */}
          <div className="font-medium text-gray-900 break-words max-w-[140px] hidden sm:block">
            {name}
          </div>
        </div>
      </div>
    </td>
  );
};

export default ColumnExerciseInformationAvatar;
